// SPDX-FileCopyrightText: 2026 Povl Filip Sonne-Frederiksen
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * The page's one SessionBridge, set up from the runtime config before the
 * first render. Null in local mode (no Supabase in `/config.json`).
 */

import { authApi } from '../api/auth';
import { createSupabaseAuth, type SupabaseAccount } from '../api/supabase';
import type { RuntimeConfig } from '../config';
import { browserCoordination, SessionBridge } from './session';
import { setRebridge } from './unauthorized';

let bridge: SessionBridge | null = null;
let account: SupabaseAccount | null = null;

export function sessionBridge(): SessionBridge | null {
  return bridge;
}

/** Self-service account calls (Konto); null in local mode or when Supabase did not start. */
export function supabaseAccount(): SupabaseAccount | null {
  return account;
}

/** Create the bridge, follow Supabase's events, and arm the 401 re-bridge. */
export async function initSession(config: RuntimeConfig): Promise<void> {
  if (!config.supabase) return;
  const client = await createSupabaseAuth(config.supabase);
  const created = new SessionBridge(client, authApi, browserCoordination());
  account = client;
  created.listen();
  bridge = created;
  setRebridge((since) => created.rebridgeFor(since));
}
